import { BoxCssSizingProperty, BoxSizeProperties } from '../Box.types';

export const formatSizeValue = (value?: BoxCssSizingProperty) => {
  if (value === undefined) return undefined;
  return isFinite(Number(value)) ? `${value}px` : `${value}`;
};

export const getSizeValues = (props: BoxSizeProperties) => {
  return Object.fromEntries(
    Object.entries(props).map(([key, value]) => [key, formatSizeValue(value)]),
  );
};
